import { Button, FormControl, Grid, TextField } from '@mui/material'
import { CustomAutocomplete } from 'common'
import React from 'react'
import { CollateralVehicle } from './CollateralVehicle'
import { ArrowLeftCircle, ArrowRightCircle } from 'react-feather'
import { CollateralRealEstate } from './CollateralRealEstate'

export const GeneralForm = ({ useFetchInit }) => {

  const {
    //------------- Generales
    //------------- globalStates
    globalStates,
    //------------- Helpers
    Helpers,
    //------------- Formularios
    Forms,
    //------------- FetchData
    FetchData,

    defaultData,

    //------------- Actions
    Actions
  } = useFetchInit

  // ------------------------------------------------ actions
  const { handleClickCloseModal, onSubmitFormCollateral } = Actions

  // ------------------------------------------------ globalStates
  const { modalOpeningMode } = globalStates

  // ------------------------------------------------ Formularios
  const { FormCollateral: { formState, onInputChange, onInputChangeForNumber, onSelectSearchChange } } = Forms


  return (
    <>
      <form onSubmit={onSubmitFormCollateral}>
        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <FormControl fullWidth>
              <label htmlFor="title">* Descipcion corta</label>
              <TextField
                id='title'
                name='title'
                value={formState.title}
                onChange={onInputChange}
                size='small'
                placeholder='Descipcion corta'
                hiddenLabel
                type='text'
                variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined'}
                InputProps={{
                  readOnly: (modalOpeningMode === 'READONLY') ? true : false
                }}
                required
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <FormControl fullWidth>
              <label htmlFor="type_collateral">* Tipo</label>
              <CustomAutocomplete
                customId="type_collateral"
                customName="type_collateral"
                customValue={formState.type_collateral}
                customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'type_collateral', value: value.value } })}
                customPlaceholder='Seleccionar un tipo de Garantia'
                customOptions={
                  defaultData.optionsTypeCollateral.map(({ value, label }) => ({
                    value: value,
                    name: label
                  }))
                }
                customDisableClearable={true}
                customDisabled={(modalOpeningMode === 'READONLY') ? true : false}
              />
            </FormControl>
          </Grid>
        </Grid>
        {formState.type_collateral === 'VEHICULO' && (
          <CollateralVehicle useFetchInit={useFetchInit} />
        )}

        {formState.type_collateral === 'BIEN INMUEBLE' && (
          <CollateralRealEstate useFetchInit={useFetchInit} />
        )}

        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>

          <Grid item xs={12} sm={12} md={12} lg={12}>
            <FormControl fullWidth>
              <label htmlFor="valor">* Valoracion de la Garantia (Q) </label>
              <TextField
                id='valor'
                name='valor'
                value={formState.valor}
                onChange={onInputChangeForNumber}
                placeholder='Valor'
                size='small'
                hiddenLabel
                type='text'
                variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined'}
                InputProps={{
                  readOnly: (modalOpeningMode === 'READONLY') ? true : false
                }}
                required
              />
            </FormControl>
          </Grid>
        </Grid>
        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <FormControl fullWidth>
              <label htmlFor="description">Descripcion </label>
              <TextField
                id='description'
                name='description'
                value={formState.description}
                onChange={onInputChange}
                placeholder='Descripcion'
                size='small'
                multiline
                rows={5}
                hiddenLabel
                type='text'
                variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined'}
                InputProps={{
                  readOnly: (modalOpeningMode === 'READONLY') ? true : false
                }}
              />
            </FormControl>
          </Grid>

        </Grid>

        <div className="border-bottom border-secondary "></div>
        <Grid container justifyContent="center" alignItems="center" style={{ height: '10%' }}>
          <Grid item xs={12}>
            <div className="text-center">
              <Button
                startIcon={<ArrowLeftCircle />}
                variant="contained"
                type="button"
                className='btn-round'
                color='warning'
                onClick={() => handleClickCloseModal(false, 'EDIT')}
                sx={{ marginRight: 1, marginLeft: 1, marginTop: 3 }}
              >
                Volver
              </Button>

              {(modalOpeningMode === 'EDITABLE') && (
                <Button
                  endIcon={<ArrowRightCircle />}
                  variant="contained"
                  type="submit"
                  className='btn-round'
                  color='primary'
                  sx={{ marginRight: 1, marginLeft: 1, marginTop: 3 }}
                >
                  Guardar
                </Button>
              )}
            </div>
          </Grid>
        </Grid>
      </form>
    </>
  )
}
